/* eslint-disable react/button-has-type */

import React from 'react';
import cn from '@/utils/cn';

interface IUnstyledButtonProps extends React.HTMLProps<HTMLButtonElement> {
  type?: 'button' | 'submit';
}

const UnstyledButton = React.forwardRef<HTMLButtonElement, IUnstyledButtonProps>(({
  className,
  children,
  type = 'button',
  ...rest
}, ref) => (
  <button
    ref={ref}
    className={cn('tw-bg-transparent tw-border-none tw-p-0 tw-cursor-pointer', className)}
    type={type}
    {...rest}
  >
    {children}
  </button>
));

export default UnstyledButton;
